import { render, staticRenderFns } from "./HomeMobileVersion.vue?vue&type=template&id=6d3d4d46&"
import script from "./HomeMobileVersion.vue?vue&type=script&lang=js&"
export * from "./HomeMobileVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports